export const invites_dataset:any = [
  {
    instructions: {
      prompt:
        "Design an inviting image for a Cookie Masterclass in the style of Sally’s Baking Addiction. Include warm tones, cookies on white napkins, and soft pastel utensils.",
      params: {
        tone: "Polite",
        words: 50,
        hashtags: false,
        emojis: true,
        network: "instagram",
        context: true,
        posts: "3",
        url: "https://sallysbakingaddiction.com/category/desserts/cookies/",
        engageOption: "SIGN UP",
      },
      meeting: {
        startTime: "July/12 13:30",
        endTime: "July/12 14:00",
        link: "http://localhost:3000/my/barbararm",
        title: "Cookie Recipes Masterclass",
        description:
          "Explore recipes for chocolate chip, sugar, and snickerdoodle cookies in this sweet baking class designed for all levels.",
      },
    },
    user_id: "",
    text: "🍪 Learn to bake irresistible cookies from scratch! Join our Cookie Masterclass this July 12, 13:30–14:00. 🧁 Includes free recipe ebook! 👉 http://localhost:3000/my/barbararm",
    imageUrl: "https://delivery-us1.bfl.ai/results/sample1.png",
    createdAt: "2025-07-10T19:25:00.000Z",
    socialMedia: "instagram",
    _id: "ckm001",
  },
  {
    instructions: {
      prompt:
        "Design an inviting image for a Cookie Masterclass in the style of Sally’s Baking Addiction. Include warm tones, cookies on white napkins, and soft pastel utensils.",
      params: {
        tone: "Polite",
        words: 50,
        hashtags: false,
        emojis: true,
        network: "instagram",
        context: true,
        posts: "3",
        url: "https://sallysbakingaddiction.com/category/desserts/cookies/",
        engageOption: "SIGN UP",
      },
      meeting: {
        startTime: "July/12 13:30",
        endTime: "July/12 14:00",
        link: "http://localhost:3000/my/barbararm",
        title: "Cookie Recipes Masterclass",
        description:
          "Explore recipes for chocolate chip, sugar, and snickerdoodle cookies in this sweet baking class designed for all levels.",
      },
    },
    user_id: "",
    text: "✨ Cookie magic is coming your way! ✨ Join our sweet masterclass on July 12 and discover pro tips for perfect baking 🍪😋 http://localhost:3000/my/barbararm",
    imageUrl: "https://delivery-us1.bfl.ai/results/sample2.png",
    createdAt: "2025-07-10T19:26:00.000Z",
    socialMedia: "facebook",
    _id: "ckm002",
  },
  {
    instructions: {
      prompt:
        "Design an inviting image for a Cookie Masterclass in the style of Sally’s Baking Addiction. Include warm tones, cookies on white napkins, and soft pastel utensils.",
      params: {
        tone: "Polite",
        words: 50,
        hashtags: false,
        emojis: true,
        network: "instagram",
        context: true,
        posts: "3",
        url: "https://sallysbakingaddiction.com/category/desserts/cookies/",
        engageOption: "SIGN UP",
      },
      meeting: {
        startTime: "July/12 13:30",
        endTime: "July/12 14:00",
        link: "http://localhost:3000/my/barbararm",
        title: "Cookie Recipes Masterclass",
        description:
          "Explore recipes for chocolate chip, sugar, and snickerdoodle cookies in this sweet baking class designed for all levels.",
      },
    },
    user_id: "",
    text: "🧁 Bake along with us! Our Cookie Masterclass is perfect for beginners and pros alike. Sign up now for a delicious session 🍪🎉 http://localhost:3000/my/barbararm",
    imageUrl: "https://delivery-us1.bfl.ai/results/sample3.png",
    createdAt: "2025-07-10T19:27:00.000Z",
    socialMedia: "instagram",
    _id: "ckm003",
  },
  {
    instructions: {
      prompt:
        "Design an inviting image for a Cookie Masterclass in the style of Sally’s Baking Addiction. Include warm tones, cookies on white napkins, and soft pastel utensils.",
      params: {
        tone: "Polite",
        words: 50,
        hashtags: false,
        emojis: true,
        network: "instagram",
        context: true,
        posts: "3",
        url: "https://sallysbakingaddiction.com/category/desserts/cookies/",
        engageOption: "SIGN UP",
      },
      meeting: {
        startTime: "July/12 13:30",
        endTime: "July/12 14:00",
        link: "http://localhost:3000/my/barbararm",
        title: "Cookie Recipes Masterclass",
        description:
          "Explore recipes for chocolate chip, sugar, and snickerdoodle cookies in this sweet baking class designed for all levels.",
      },
    },
    user_id: "",
    text: "📚 Bonus recipe ebook included! Learn baking secrets and get cozy with us this Friday in our cookie masterclass 🍪💛 http://localhost:3000/my/barbararm",
    imageUrl: "https://delivery-us1.bfl.ai/results/sample4.png",
    createdAt: "2025-07-10T19:28:00.000Z",
    socialMedia: "x",
    _id: "ckm004",
  },
  {
    instructions: {
      prompt:
        "Design an inviting image for a Cookie Masterclass in the style of Sally’s Baking Addiction. Include warm tones, cookies on white napkins, and soft pastel utensils.",
      params: {
        tone: "Polite",
        words: 50,
        hashtags: false,
        emojis: true,
        network: "instagram",
        context: true,
        posts: "3",
        url: "https://sallysbakingaddiction.com/category/desserts/cookies/",
        engageOption: "SIGN UP",
      },
      meeting: {
        startTime: "July/12 13:30",
        endTime: "July/12 14:00",
        link: "http://localhost:3000/my/barbararm",
        title: "Cookie Recipes Masterclass",
        description:
          "Explore recipes for chocolate chip, sugar, and snickerdoodle cookies in this sweet baking class designed for all levels.",
      },
    },
    user_id: "",
    text: "🥣 Baking made joyful! Join our Cookie Masterclass July 12 and let’s whip up something sweet and cozy together 🍪💕 http://localhost:3000/my/barbararm",
    imageUrl: "https://delivery-us1.bfl.ai/results/sample5.png",
    createdAt: "2025-07-10T19:29:00.000Z",
    socialMedia: "tiktok",
    _id: "ckm005",
  },
  {
    instructions: {
      prompt:
        "Design an inviting image for a Cookie Masterclass in the style of Sally’s Baking Addiction. Include warm tones, cookies on white napkins, and soft pastel utensils.",
      params: {
        tone: "Polite",
        words: 50,
        hashtags: false,
        emojis: true,
        network: "instagram",
        context: true,
        posts: "3",
        url: "https://sallysbakingaddiction.com/category/desserts/cookies/",
        engageOption: "SIGN UP",
      },
      meeting: {
        startTime: "July/12 13:30",
        endTime: "July/12 14:00",
        link: "http://localhost:3000/my/barbararm",
        title: "Cookie Recipes Masterclass",
        description:
          "Explore recipes for chocolate chip, sugar, and snickerdoodle cookies in this sweet baking class designed for all levels.",
      },
    },
    user_id: "",
    text: "🎉 Two days of sweet fun! Our Cookie Masterclass includes live baking tips, Q&A, and a free guide. 🍪 Sign up today 👉 http://localhost:3000/my/barbararm",
    imageUrl: "https://delivery-us1.bfl.ai/results/sample6.png",
    createdAt: "2025-07-10T19:30:00.000Z",
    socialMedia: "linkedin",
    _id: "ckm006",
  },
];
